import { licenseTypeService } from '_services';
import { ACTIONS_LICENSE_TYPE } from '_constants/licenseType.constants';
import alertActions from './alert.actions';

export const receiveLicenseTypes = (licenseTypes) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < licenseTypes.length; i++) {
    byIdObjectToDispatch[licenseTypes[i].id] = licenseTypes[i];
  }

  return {
    type: ACTIONS_LICENSE_TYPE.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteLicenseType = (id) => ({
  type: ACTIONS_LICENSE_TYPE.DELETE,
  byId: { [id]: null }
});

const getLicenseTypes = () => async (dispatch) => {
  try {
    const resp = await licenseTypeService.getLicenseTypes();
    if (resp?.[0]?.id) {
      dispatch(receiveLicenseTypes(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving licence types.'));
  }
  return null;
};

export default {
  getLicenseTypes,
};
